import { styled } from '@mui/system';
import { Box, Divider, Paper, Typography } from '@mui/material';

export const StyledBox = styled(Box, {
    shouldForwardProp: (prop) => prop !== 'align',
})<{ align?: 'left' | 'right' }>(({ theme }) => ({
    backgroundImage: 'url(/images/platines.jpg)',
    backgroundSize: 'cover',
    backgroundPosition: 'center',
    backgroundAttachment: 'scroll',
    minHeight: 'auto',
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'flex-start',
    alignItems: 'center',
    padding: '30px 10px',
    [theme.breakpoints.up('xl')]: {
        backgroundAttachment: 'fixed',
        padding: '60px 20px',
    },
    [theme.breakpoints.down('sm')]: {
        display: 'none',
    },
}));

export const StyledPaper = styled(Paper, {
    shouldForwardProp: (prop) => prop !== 'align',
})<{ align?: 'left' | 'right' }>(({ theme }) => ({
    backgroundColor: 'rgba(255, 255, 255, 0.8)',
    borderRadius: 10,
    padding: 2,
    width: '95%',
    maxWidth: 800,
    textAlign: 'center',
    alignItems: 'center',
    color: '#AE29D5',
    boxShadow: '0px 0px 10px 2px rgba(174, 41, 213, 0.8)',
    margin: '0 auto',
    [theme.breakpoints.up('xl')]: {
        padding: 3,
        width: '80%',
    },
}));

export const StyledDivider = styled(Divider)(({ theme }) => ({
    width: '30%',
    margin: '20px auto',
    border: 'none',
    borderTop: '2px solid #AE29D5',
}));

export const TitleTypography = styled(Typography)(({ theme }) => ({
    fontSize: '2rem',
    fontWeight: 700,
    position: 'relative',
    color: '#AE29D5',
    textShadow: '0 0 10px rgba(174, 41, 213, 0.6)',
    '&::before': {
        content: '""',
        position: 'absolute',
        top: '0',
        left: '0',
        right: '0',
        bottom: '0',
        filter: 'blur(8px)',
        zIndex: -1,
    },
}));

export const StyledBigTitle = styled(Typography)(({ theme }) => ({
    width: '100%',
    textAlign: 'center',
    fontSize: '3rem',
    fontWeight: 700,
    color: theme.palette.info.main,
    zIndex: 1000,
    pointerEvents: 'none',
    marginBottom: '20px',
    [theme.breakpoints.down('sm')]: {
        fontSize: '2rem',
    },
}));
